import clsx from 'clsx';
import type { CSSProperties, JSX, ReactNode } from 'react';

interface SiteBodyProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  scrollable?: boolean;
  subtractFooter?: boolean;
  id?: string;
}

export function SiteBody({
  children,
  className,
  style,
  scrollable = true,
  subtractFooter = true,
  id,
}: SiteBodyProps): JSX.Element {
  const minHeight = subtractFooter
    ? 'calc(var(--layout-safe-viewport, 100vh) - var(--layout-header-height, 0px) - var(--layout-footer-height, 0px))'
    : 'calc(var(--layout-safe-viewport, 100vh) - var(--layout-header-height, 0px) - var(--layout-footer-height, 0px))';
  const lockedHeight = scrollable ? undefined : minHeight;

  const bodyStyle: CSSProperties = {
    minHeight,
    ...(lockedHeight ? { height: lockedHeight, maxHeight: lockedHeight } : {}),
    paddingBottom: subtractFooter ? undefined : 'var(--layout-footer-height, 0px)',
    ...style,
  };

  const scrollClass = scrollable ? 'overflow-y-auto' : 'overflow-hidden';
  const heightClass = 'h-full';

  return (
    <main
      id={id}
      data-testid="site-body"
      className={clsx('flex min-h-0 flex-1 flex-col', heightClass, scrollClass, className)}
      style={bodyStyle}
    >
      {children}
    </main>
  );
}
